export default __webpack_public_path__ + "static/wvs-india-seo-99533ea5f461aad3e297cebfc5abf435.jpg";